"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable class-methods-use-this */
const crypto_1 = require("crypto");
class NodeCrypto {
    createHash(algorithm) {
        return (0, crypto_1.createHash)(algorithm);
    }
    createHmac(algorithm, key) {
        return (0, crypto_1.createHmac)(algorithm, key);
    }
    randomUUID() {
        return (0, crypto_1.randomUUID)();
    }
}
exports.default = NodeCrypto;
//# sourceMappingURL=NodeCrypto.js.map